import { AccessRelationship } from "@istari/istari-client";

import { InternalUserType } from "~/api/user/user";
import { OrgUser } from "~/types/orgUser";
import { UNKNOWN_USER_DISPLAY_NAME } from "~/user/utils/format-user-name";

export const checkIsResourceOwner = (
  creatorId: string | undefined,
  userSubId: string | undefined | null,
  userList: InternalUserType[] | undefined,
): boolean => {
  const currentUserId = userList?.find((user) => user.providerUserId === userSubId)?.id;
  return creatorId === currentUserId;
};

export const getUserName = (userList: OrgUser[] | undefined, userId: string | undefined | null): string | undefined => {
  const userMap: { [key: string]: OrgUser } | undefined = userList?.reduce(
    (acc, user) => ({
      ...acc,
      [user.id]: user,
    }),
    {} as { [key: string]: OrgUser },
  );
  const user: OrgUser | undefined = userId ? userMap?.[userId] : undefined;
  return user ? `${user?.firstName} ${user?.lastName}` : UNKNOWN_USER_DISPLAY_NAME;
};

export const getCrossTenantUserName = (accessList: AccessRelationship[], userId: string | undefined | null) => {
  const userMap: { [key: string]: AccessRelationship } | undefined = accessList?.reduce(
    (acc, user) => ({
      ...acc,
      [user.subjectId]: user,
    }),
    {} as { [key: string]: AccessRelationship },
  );
  const user: AccessRelationship | undefined = userId ? userMap?.[userId] : undefined;
  return user ? user.subjectInfo?.username : UNKNOWN_USER_DISPLAY_NAME;
};

/**
 * Filters users from an access list based on user subject type and returns them in AvatarList format
 * @param accessList - Array of access relationships
 * @param orgUsers - Array of organization users
 * @returns Array of users formatted with that access
 */
export const getUsersWithAccess = (
  accessList: AccessRelationship[] | undefined,
  orgUsers: InternalUserType[] | undefined,
) => {
  if (!accessList || !orgUsers) return [];

  const userSubjectIds = accessList
    .filter((rel) => String(rel.subjectType).toLowerCase() === "user")
    .map((rel) => rel.subjectId);
  const unique = Array.from(new Set(userSubjectIds));

  return unique
    .map((id) => orgUsers.find((u) => u.id === id))
    .filter(Boolean)
    .map((u) => ({
      id: u!.id,
      firstName: u!.firstName,
      lastName: u!.lastName,
      fullName: u!.fullName || `${u!.firstName ?? ""} ${u!.lastName ?? ""}`.trim(),
      email: u!.email,
    }));
};
